export const nav = {
    permission: 'ata.files:ver',
    section: 'Settings',
    title: 'Files',
    icon: 'folder_open',
    route: '/files',
    sequence: 16, // ver comentario em modules/categorias/routes.js
};

export default [
    {
        path: '/files',
        name: 'files',
        component: () => import('./pages/FilesPage.vue'),
        meta: { requiresAuth: true, permission: 'ata.files:ver' },
    },
];
